import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Book } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { BookActions } from './book.actions';
import { MethodActions } from '../method/method.actions';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import { mapBook } from './book.functions';
import { mapMethodsToBooks } from '../method/method.functions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const BOOK_FEATURE_KEY: string = 'book';

export interface BookState extends EntityState<Book> {
  fullyLoadedIds: string[];
  tocCallState: CallState;
}

export const bookAdapter: EntityAdapter<Book> = createEntityAdapter<Book>();

export const initialBookState: BookState = bookAdapter.getInitialState({
  fullyLoadedIds: [],
  tocCallState: LoadingState.INIT,
});

const reducer: ActionReducer<BookState, Action> = createReducer(
  initialBookState,
  on(AuthActions.logoutSuccess, (): BookState => initialBookState),
  on(
    MethodActions.getMethodsForScopeSuccess,
    (state, action): BookState =>
      bookAdapter.upsertMany(mapMethodsToBooks(action.methodsForScopeDto), {
        ...state,
      }),
  ),
  on(
    BookActions.getBook,
    (state): BookState => ({
      ...state,
      tocCallState: LoadingState.LOADING,
    }),
  ),
  on(
    BookActions.getBookSuccess,
    (state, action): BookState =>
      bookAdapter.upsertOne(mapBook(action.book), {
        ...state,
        fullyLoadedIds: [...state.fullyLoadedIds, action.book.id],
        tocCallState: LoadingState.LOADED,
      }),
  ),
  on(
    BookActions.getBookFailure,
    (state, { error }): BookState => ({
      ...state,
      tocCallState: { errorMsg: error.message },
    }),
  ),
);

export function bookReducer(
  state: BookState | undefined,
  action: Action,
): BookState {
  return reducer(state, action);
}
